import { IPageItem } from '../../routes/courseDashboard/features/coursePages/CoursePageList';
import { TTreeViewModel } from '../../services/models/CourseViewModels';

export function convertToAntdTree(nodes: TTreeViewModel[], addDropSpacer = true): IPageItem[] {
  function recurse(node: TTreeViewModel): IPageItem {
    return {
      id: parseInt(node.id),
      key: node.id,
      title: node.data.title.value || node.data.name,
      data: node.data,
      children: node.children.map(recurse),
      isExpanded: node.isExpanded,
    };
  }

  const result = nodes.map(recurse);

  if (addDropSpacer) {
    result.push({
      key: '__drop_spacer__',
      title: '',
      id: 9999,
      data: {} as any,
      children: [],
      isExpanded: false,
      disabled: true,
      selectable: false,
    });
  }

  return result;
}

export const getExpandedKeys = (aList: IPageItem[]): string[] => {
  const tempList: string[] = [];
  aList.forEach((node) => {
    if (node.isExpanded) {
      tempList.push(String(node.key));
      if (node.children && node.children.length > 0) {
        tempList.push(...getExpandedKeys(node.children));
      }
    }
  });
  return tempList;
};
